import {
    ChangeDetectorRef,
    Component, ElementRef, HostListener, Inject, Input, Renderer2, ViewChild,EventEmitter,Output

} from '@angular/core';
import { DialogManagerService } from '@src/services';
import { AffectedDialogComponent } from '@app/shared/components/dialogs/affected-tag-dialog/affected-tag-dialog.component';
import { TagObjectDialogComponent } from  '@app/shared/components/dialogs/tag-objects-dialog/tag-objects-dialog.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
// import { environmentsActions } from '@src/store/reducers/environmentsReducer';
// import { projectsActions } from '@src/store/reducers/projectsReducer';
// import { Store } from '@src/store';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';

export const imageByType = {
    '2': 'redCircle',
    '1': 'orangeCircle',
    '0': 'greenCircle '
};

export interface IDeployedPackagesTable {
    packageName: string;
    packageCreatedBy: string;
    AffectedObjects: string;
    projectId: number;
    action: string;
    EnvironmentName: string;
    executedBy: string;
    JobId: number;
    PackageTags: string;
}

@Component({
    selector: 'deployed-packages-details-data',
    template: require('./deployed-packages-details-data.component.html'),
    styles: [require('./deployed-packages-details-data.component.scss')]
})
export class DeployedPackagesDetailsDataComponent {
    public projectId: any;
    public criteria: any;
    public dplModeType: any;
    public environmentId: string;
    private envDetail: any;
    public page = 1;
    public isAscCreatedBy:boolean = false 
    private renderComp: boolean;
    @Output() public getRecords = new EventEmitter();
    @Output() public filter = new EventEmitter();
    @Output() public  flagpag = new EventEmitter();
    @Input() public isHistory: boolean = false;
    @Input() public resetSize:boolean;
    @Input() public set Criteria(data){
        this.criteria = data.data
    };

    public get Criteria() {
        return this.criteria;
    }

    public get data() {
        return this._data;
    }

    @Input() public set data(value) {
        if (value) {
            this._data = value;
            const data = [];
            value.forEach((item) => {
                item.tagsNames = item.tags ? item.tags.map(m => m.displayName).join(', ') : '';
                data.push({
                    PackageTags: item.PackageTags ? this.displayTags(item.PackageTags) : "NA",
                    tags:item.PackageTags,
                    ProjectName: item.ProjectName ? item.ProjectName : "NA",
                    packageName: item.PackageName ? item.PackageName : "NA",
                    JobId: item.JobId,
                    id: item.id,
                    projectId: item.ProjectId,
                    action: item.Action ? item.Action : "NA",
                    AffectedObjects: item.AffectedObjects ? item.AffectedObjects : "NA",
                    CreatedBy: item.CreatedBy ? item.CreatedBy : "NA",
                    EnvironmentName: item.EnvironmentName ? item.EnvironmentName : "NA",
                    executedBy: item.ExecutedBy ? item.ExecutedBy : "NA",
                    jobCreated: this.convertUTCtoLocal(item.CreatedDT),
                    jobStarted: this.convertUTCtoLocal(item.StartedDT),
                    jobEnded: this.convertUTCtoLocal(item.EndDT),
                    duration: item.Duration
                });
            });
            this.dataSource.data = data;
        }
    }
    // tslint:disable-next-line:variable-name
    private _data: any;

    public displayedColumns = ['projectName', 'action', 'packageName', 'JobId', 'packagesTags', 'affectedObjects', 'packageCreatedBy', 'environmentName', 'executedBy', 'jobCreated', 'jobStarted', 'jobEnded', 'duration'];
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
   // private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;
    
    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'projectName', width: 150 },
        { field: 'action', width: 150 },
        { field: 'packageName', width: 150 },
        { field: 'JobId', width: 120 },
        { field: 'packagesTags', width: 150 },
        { field: 'affectedObjects', width: 150 },
        { field: 'packageCreatedBy', width: 150 },
        { field: 'environmentName', width: 50 },
        { field: 'executedBy', width: 150 },
        { field: 'jobCreated', width: 150 },
        { field: 'jobStarted', width: 150 },
        { field: 'jobEnded', width: 100 },
        { field: 'duration', width: 150 }
    ];

    constructor(@Inject('$state') private $state: any,
        // private store: Store,
        @Inject('$stateParams') stateParams: any,
        private renderer: Renderer2,
        private dialogManagerService: DialogManagerService,
        private cdr: ChangeDetectorRef,
        //private affectedObjects: BeautifyListPipe,
        @Inject('processDetailsModalService') private processDetailsModalService: any

    ) {
        this.projectId = stateParams.id;
        this.environmentId = stateParams.envID;

    }

    onViewAffectedData(array) {
        if(Array.isArray(array)){
        this.dialogManagerService.showDialog({ elements: array }, null, AffectedDialogComponent, 'affected-tag-dialog')
        }

    }

    onViewTagsData(array){
        var arr = array?.tags ? array.tags : "NA"
        if(arr != "NA"){
            let arrCust = this.convertTagToJson(arr);
            this.dialogManagerService.showDialog({ elements: arrCust}, null, TagObjectDialogComponent, 'tag-objects-dialog');
        }
   
    }
 
    convertTagToJson(tags){
        let arr = [];
        for (let [key] of Object.entries(tags)) {
            tags[key].map(x => {
                arr.push({type : key , name : x});
            })
        }
        return arr
    }

    displayTags(tags)
    {
        let tagsString = "";
        let firstTags = true;
        if(tags)
        for (let [key,value] of Object.entries(tags)) {
            
            if(firstTags)
            {
                if(key){
                    
                }
                firstTags = false;
                tagsString = tagsString + value;
            }
            else
                tagsString = tagsString + "," + value;
        }
        const result = tagsString.replace(/,/g, ', ');;
        if(result === "")
            return "NA"
        else
            return result;
    }

    ngOnChanges() {
        if (this.renderComp) {
            this.cdr.detectChanges();
        }
    }

    customSort(colName)
    {
  
         this.isAscCreatedBy = !this.isAscCreatedBy; 
         this.page = 1
         this.flagpag.emit(false)
            this.filter.emit(  
                {data: {manualSorting: {colName: colName,isAscending: this.isAscCreatedBy},
                        project:  this.Criteria.project ,
                        fromDate: this.Criteria.fromDate,
                        toDate: this.Criteria.toDate,
                        tag: this.Criteria.tag,
                        package: this.Criteria.package,
                        user:this.Criteria.user
                        }
                    }
            )
        
    }

    public async ngOnInit() {
// this.dataSource.sort = this.sort;

    }

    scroll(event: any) {
        if(this.resetSize == true){
            this.page = 1
        }
        if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight && event.target.scrollTop !== 0) {
            this.page += 1
            this.flagpag.emit(true)
            this.getRecords.emit(this.page)
        }
    }

    public ngAfterViewInit() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    convertUTCtoLocal(date) {
        if (!date)
            return;
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }

    


    public navigate(event: any, sref: any, params: any) {
        event.preventDefault();
        this.$state.go(sref, params);
    }

    public isActionColumnVisible(): boolean {
        if (!(this.envDetail && this.envDetail.environments)) {
            return false;
        }
        const environment = this.envDetail.environments.find(m => m.id.toString() === this.environmentId);
        if (!environment) {
            return false;
        }
        return !this.isHistory && this.dplModeType === 'ByTask' && !environment.isManaged && !environment.isRMSource;
    }

    private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }
    

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
       // this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }

    public getImage(type: any) {
        return `dbm-${imageByType[type]}`;
    }

    public showActivityDetails(item: any) {
        if (item.JobId != null) {
            const activityIcon = this.getImage(0);
            this.processDetailsModalService.OpenProcessDetailsModal({ activityIcon, JobQId: item.JobId }, true)
        }
    }


    private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
               // if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
               // }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
           //     this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            }
        }   
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

    public getTagsName(tags: any): string {
        return tags.map(t => t.displayName).join(',');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/deployed-packages-details/deployed-packages-details-data/deployed-packages-details-data.component.ts